import { Box } from '@mui/system';
import React from 'react';
import errorPage from '../../assets/images/errors/banner_560x430_link non valido.svg';
import { GenericErrorTemplate } from '../../components/GenericErrorTemplate';

export const AppNotFoundPage: React.FC = () => {

    const description = (
        <Box>
            <p>
                Si è verificato un errore nell'apertura della pagina.
            </p>
            <p>
                Contatta l'assistenza se il problema persiste.
            </p>
        </Box>
    );

    return (
        <GenericErrorTemplate
            title="Attenzione!"
            description={description}
            hideAppBar
            image={{
                alt: "Generic error image",
                src: errorPage,
                style: {
                    width: 'auto',
                    height: '321px'
                }
            }}
        />
    );
};
